import { ModalFooter } from "@nextui-org/react";
import Button from "../../../Button/Button";
import styles from "./ButtonsFooter.module.scss";

interface Props {
  isLoading?: boolean;
  isMobile?: boolean;
  primaryButton: {
    text: string;
    handleClick: () => void;
    isDisabled?: boolean;
  };
  secondaryButton?: {
    text: string;
    handleClick: () => void;
    isDisabled?: boolean;
  };
}

export const ButtonsFooter = ({
  isLoading,
  primaryButton,
  secondaryButton,
  isMobile = false,
}: Props) => {
  const { button, footer } = styles;

  return (
    <ModalFooter className={isMobile ? "px-0 py-0" : "py-8 px-5"}>
      <div className={footer}>
        {secondaryButton && (
          <Button
            text={secondaryButton?.text}
            variant="secondary"
            className={button}
            onPress={secondaryButton?.handleClick}
            isDisabled={secondaryButton?.isDisabled}
            isLoading={isLoading}
          />
        )}
        <Button
          text={primaryButton.text}
          className={button}
          onPress={primaryButton.handleClick}
          isDisabled={primaryButton?.isDisabled}
          isLoading={isLoading}
        />
      </div>
    </ModalFooter>
  );
};
